<template>
  <div>
    <v-tabs
      v-if="!(isLoadingEnsaio || isLoadingList)"
      v-model="indiceAba"
      class="abas-padrao valores-calibracao-tab"
      :class="'valores-calibracao-tab'"
      background-color="primary"
      color="primary"
      fixed-tabs
      @change="salvarAoMudar"
    >
      <v-tab>
        {{ $t('modulos.calibracao.formulario.abas.dados') }}
      </v-tab>
      
      <v-tab v-if="0">
        Ensaio calibração
      </v-tab>
      
      <v-tab v-if="0">
        Faixas
      </v-tab>
      
      <v-tab v-if="0">
        Instrumentos Padrões
      </v-tab>
    </v-tabs>
    <v-progress-circular
      v-if="isLoadingEnsaio || isLoadingList"
      indeterminate
      color="primary"
      class="mx-auto my-4 progress-circular"
    />
    <div class="mt-10" v-if="!(isLoadingEnsaio || isLoadingList)">
      <v-tabs-items
        v-model="indiceAba"
      >
        <v-tab-item>
          <v-card flat>
            <TabEnsaio
              v-if="1"
              :ensaio-dados="ensaioDados"
            />
            <div
              v-else
              class="empty-state mt-3"
            >
              <p>Sem dados de ensaio disponíveis.</p>
            </div>
          </v-card>
        </v-tab-item>
        
        <v-tab-item v-if="0">
          <v-card flat>
            <v-simple-table
              dense
              class="mt-3 tabela-dinamica-calibracao"
            >
              <thead v-if="0">
                <tr>
                  <th>{{ $t('modulos.calibracao.valores.tipo') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.chave') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.valor') }}</th>
                </tr>
              </thead>
              <tbody v-if="ensaioCalibracao.length > 0">
                <tr
                  v-for="calibracao in ensaioCalibracao"
                  :key="`calibracao-${calibracao.tipo}-${calibracao.chave}`"
                >
                  <td>{{ calibracao.tipo }}</td>
                  <td>{{ calibracao.chave }}</td>
                  <td>{{ calibracao.valor }}</td>
                </tr>
              </tbody>
              <div
                v-else
                class="empty-state"
              >
                <p>Sem dados de calibração disponíveis.</p>
              </div>
            </v-simple-table>
          </v-card>
        </v-tab-item>
        
        <v-tab-item v-if="0">
          <v-card flat>
            <v-simple-table
              dense
              class="mt-3 tabela-dinamica-calibracao"
            >
              <thead v-if="0">
                <tr>
                  <th>{{ $t('modulos.calibracao.valores.faixa') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.chave') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.valor') }}</th>
                </tr>
              </thead>
              <tbody v-if="ensaioFaixas.length > 0">
                <tr
                  v-for="faixa in ensaioFaixas"
                  :key="`faixa-${faixa.faixa}-${faixa.chave}`"
                >
                  <td>{{ faixa.faixa }}</td>
                  <td>{{ faixa.chave }}</td>
                  <td>{{ faixa.valor }}</td>
                </tr>
              </tbody>
              <div
                v-else
                class="empty-state"
              >
                <p>Sem dados de faixas disponíveis.</p>
              </div>
            </v-simple-table>
          </v-card>
        </v-tab-item>
        
        <v-tab-item v-if="0">
          <v-card flat>
            <v-simple-table
              dense
              class="mt-3 tabela-dinamica-calibracao"
            >
              <thead v-if="0">
                <tr>
                  <th>{{ $t('modulos.calibracao.valores.canal') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.codigoTag') }}</th>
                  <th>{{ $t('modulos.calibracao.valores.faixa') }}</th>
                </tr>
              </thead>
              <tbody v-if="ensaioInstrumentosPadroes.length > 0">
                <tr
                  v-for="instrumento in ensaioInstrumentosPadroes"
                  :key="`instrumento-${instrumento.canal}-${instrumento.codigoTag}`"
                >
                  <td>{{ instrumento.canal }}</td>
                  <td>{{ instrumento.codigoTag }}</td>
                  <td>{{ instrumento.faixa }}</td>
                </tr>
              </tbody>
              <div
                v-else
                class="empty-state"
              >
                <p>Sem dados de instrumentos disponíveis.</p>
              </div>
            </v-simple-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex';
import CalibracaoService from '../../../../../../common/services/cadastros/CalibracaoService';
import TabEnsaio from './tabEnsaio.vue';

  export default {
    components:{
      TabEnsaio
    },
    props: {
      calibracaoId:{},
      calibracaoFaixaId:{}
    },
    data(){
      return {
        abaAtiva: 0,
        indiceAba: 0, 
        ensaioInstrumentosPadroes:[],
        ensaioFaixas:[],
        ensaioCalibracao:[],
        ensaioDados:[],
        isLoadingList: false
      }
    },  
    computed: {
      ...mapGetters('Calibracao', ['isLoadingEnsaio']),
      groupedEnsaioDados() {
        this.ensaioDados.map(item => {
          return {
            ...item,
            data: new Date(item.data).toLocaleDateString('pt-BR')
          };
        });
        const grouped = this.ensaioDados.reduce((acc, item) => {
          if (!acc[item.canal]) {
            acc[item.canal] = {};
          }
          if (!acc[item.canal][item.sequencia]) {
            acc[item.canal][item.sequencia] = [];
          }
          acc[item.canal][item.sequencia].push(item);
          return acc;
        }, {});

        const orderedGrouped = {};
        Object.keys(grouped)
          .sort()
          .forEach(key => {
            orderedGrouped[key] = grouped[key];
          });

        return orderedGrouped;
      }
    },
    watch: {
      isLoadingEnsaio(newVal) {
        if (!newVal) {
          this.setup()
        }
      },
    },
    mounted(){
      this.setup()
    },
    methods: {
      setup() {
        this.isLoadingList = true
       
        CalibracaoService.ensaioLista(this.calibracaoId, this.calibracaoFaixaId)
          .then((res) => {
            const {
              ensaioInstrumentosPadroes,
              ensaioFaixas,
              ensaioCalibracao,
              ensaioDados,
            } = res.data;

            this.ensaioInstrumentosPadroes = ensaioInstrumentosPadroes;
            this.ensaioFaixas = ensaioFaixas;
            this.ensaioCalibracao = ensaioCalibracao;
            this.ensaioDados = ensaioDados.map(item => ({
              ...item,
              data: new Date(item.data).toLocaleDateString('pt-BR') + ' ' + new Date(item.data).toLocaleTimeString('pt-BR')
            }));
          })
          .finally(() => {
            this.$store.dispatch('Layout/');
            this.isLoadingList = false
          });
      },
      salvarAoMudar(novoIndice) {
        this.$emit("aba-mudou", novoIndice);
      },
      groupedEnsaioDadosPaginados() {
        const dadosAgrupados = this.groupedEnsaioDados;
        const inicio = (this.paginaAtual - 1) * this.tamanhoPagina;
        const fim = inicio + this.tamanhoPagina;
        const dadosPaginados = {};

        Object.keys(dadosAgrupados).forEach(canal => {
          const sequencias = Object.keys(dadosAgrupados[canal]);
          sequencias.forEach(sequencia => {
            const linhas = dadosAgrupados[canal][sequencia];
            const linhasPaginadas = linhas.slice(inicio, fim);
            if (linhasPaginadas.length) {
              if (!dadosPaginados[canal]) {
                dadosPaginados[canal] = {};
              }
              dadosPaginados[canal][sequencia] = linhasPaginadas;
            }
          });
        });
        return dadosPaginados;
      },
    }
  };
</script>
<style >
.valores-calibracao-tab .v-slide-group__wrapper{
  height: 30px;
}
.valores-calibracao-tab {
  height: 30px;
}
.valores-calibracao-tab .v-tab{
  height: 30px;
}
.valores-calibracao-tab .v-slide-group__wrapper{
  height: 30px !important;
}
.valores-calibracao-tab .v-item-group{
  height: 30px !important;
  margin-top: 24px;
}
.empty-state{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.progress-circular{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
  